import React from 'react';
import { SingleChainActionIcon } from 'components/ScenarioSetup/ActionIcons/SingleChainActionIcon';
import { RepeatTriggerIcon } from 'assets/icons/RepeatTriggerIcon';
import { RepeatTriggerIconAlt } from 'assets/icons/RepeatTriggerIconAlt';

export const RepeatTrigger = ({ id, actionType, title, isShowWarningActionMessage, isOpenActionInfo }) => {

    const actionIconConditions = {
        base: {
            icon: RepeatTriggerIcon,
            iconProps: {
                width: '48px',
                height: '48px',
                color: '#FFFFFF',
                bgColor: '#9088DF'
            }
        },
        opened: {
            icon: RepeatTriggerIconAlt,
            iconProps: { borderColor: '#9088DF' }
        },
        warning: {
            icon: RepeatTriggerIconAlt,
            iconProps: { borderColor: '#FC4A54' }
        }
    }

    return <SingleChainActionIcon {...{
        id,
        actionType,
        title,
        isShowWarningActionMessage,
        isOpenActionInfo,
        actionIconConditions
    }} />
}
